import axios from 'axios'
import _ from 'lodash'
import { getStore, keys } from '../store'
import router from '../router'

// const baseUrl = 'https://classover2.ysdftech.com'//测试
const baseUrl = 'https://app.classover.com'//正式


export default function request(config) {
    return new Promise((resolve, reject) => {
        let token = getStore(keys.token)
        let lang = getStore(keys.lang)
        if (token)
            token = `Bearer ${token}`
        axios(_.merge(config, {
            url: baseUrl + config.url,
            headers: {
                Authorization: token,
                lan: lang
            }
        })).then((data) => {
            if (data.data.code == 200)
                resolve(data.data.data)
            else if ([10001, 10002, 10003].includes(data.data.code)) {
                router.push({ path: '/login' })
            }
            else if(data.data.code==405) {//点击continue跳转页面返回405报错之后返回上一页
                reject(data.data)
                alert(data.data.msg)
                router.push({ path: '/' })
            }
            else if(data.data.code==400) {
                if(window.location.href.indexOf('plan-detail') !=-1){
                    reject(data.data.data)
                    console.log(data.data)
                }
                else if(window.location.href.indexOf('login') !=-1){
                    reject(data.data)
                    alert(data.data.msg)
                }
                else{
                    reject(data.data)
                    alert(data.data.msg)
                }
            }
            else {
                reject(data.data)
                alert(data.data.msg)
            }
        }).catch((error) => {
                reject(error)
        })
    }).catch((error)=>{
        if(window.location.href.indexOf('plan-detail') !=-1){
            return ''
        }else if(window.location.href.indexOf('login') !=-1){
            if(error.msg=='Password input error'){
                return error.msg
            }
        }
        else{

        }
        })
}

export function get(url, data) {
    return request({
        url: url,
        method: 'get',
        data: data
    })
}

export function post(url, data) {
    return request({
        url: url,
        method: 'post',
        data: data
    })
}

export function put(url, data) {
    return request({
        url: url,
        method: 'put',
        data: data
    })
}

export function remove(url, data) {
    return request({
        url: url,
        method: 'delete',
        data: data
    })
}



// WEBPACK FOOTER //
// ./src/api/request.js